export function listPromptVariables(texts: string | Array<string | undefined | null>): string[] {
  const list = Array.isArray(texts) ? texts : [texts];
  const found: string[] = [];
  const re = /\{([a-zA-Z][a-zA-Z0-9_]*)\}/g;
  for (const text of list) {
    if (typeof text !== "string" || text.length === 0) continue;
    let match: RegExpExecArray | null;
    while ((match = re.exec(text)) !== null) {
      const name = match[1];
      const before = match.index > 0 ? text[match.index - 1] : "";
      const afterIndex = match.index + match[0].length;
      const after = afterIndex < text.length ? text[afterIndex] : "";
      if (before === '"' || before === ":" || after === '"' || after === ":") continue;
      if (name.length <= 1) continue;
      if (!found.includes(name)) found.push(name);
    }
    re.lastIndex = 0;
  }
  return found;
}
